import { LvfHandlingEnergyType } from '../../../enum/supplychain/lvf-handling-energy-type';
import { LvfVehicleModelType } from '../../../enum/supplychain/lvf-vehicle-model-type';

export interface IEquipmentVehicleModelExtensionInfo {
  LvfVehicleModelType?: LvfVehicleModelType;
  LvfHandlingEnergyType?: LvfHandlingEnergyType;
}

export class EquipmentVehicleModelExtension {
  LvfVehicleModelType?: LvfVehicleModelType;
  LvfHandlingEnergyType?: LvfHandlingEnergyType;

  constructor(info: IEquipmentVehicleModelExtensionInfo) {
    this.LvfVehicleModelType = info.LvfVehicleModelType;
    this.LvfHandlingEnergyType = info.LvfHandlingEnergyType;
  }
}
